import mixpanel from 'mixpanel-browser'
import TagManager from 'react-gtm-module';

import { UserService } from './storage.service';
import { getGTMEventFromName, isActive } from '../helpers';
import { GTM_SWITCH, GTM_TOKEN, MIXPANEL_SWITCH, MIXPANEL_TOKEN } from '../constants';


const Tracking = {

    initializeTracking() {
        if (isActive(GTM_SWITCH)) 
            TagManager.initialize({
                gtmId: GTM_TOKEN,
            })
    },

    trackMixpanel(label, props) {
        console.log({
            [label]: {
                ...props
            }
        })
        if (isActive(MIXPANEL_SWITCH)) {
            mixpanel.init(MIXPANEL_TOKEN)
            mixpanel.track(label, props)
        }
    },

    trackGTM({ event, ...props }) {
        if (event && isActive(GTM_SWITCH))  
            TagManager.dataLayer({       
                dataLayer: {
                    event,
                    ...props
                }
            });
    },

    setUserForTracking(registrationDate, userId) {
        const { REGISTRATION } = TRACKING_CONSTANTS;

        if (isActive(MIXPANEL_SWITCH))
            mixpanel.people.set({
                "Registration Date": registrationDate,
                "User ID": userId,
            });

        this.startUserTracking(userId);
        this.trackMixpanel(REGISTRATION, { user: userId });
    },

    trackPage({ pageName, pageTitle = null, ...props }) {
        const { VIEW } = TRACKING_CONSTANTS;
        const { VARIANT, PAGE_NAME, PAGE_TITLE } = TRACKING_PAGE_PROPS;

        const pageProps = {
            [VARIANT]: "Control",
            [PAGE_NAME]: pageName,
            [PAGE_TITLE]: pageTitle,
            ...props
        }

        this.trackMixpanel(VIEW, pageProps);
        this.trackGTM({ event: getGTMEventFromName(pageName), ...props });

    },

    trackLink(label, type, context, gtmEvent = null, gtmProps) {
        const { CLICK } = TRACKING_CONSTANTS;
        const { LABEL, TYPE, CONTEXT } = LINK_PROPS;

        const linkProps = {
            [LABEL]: label,
            [TYPE]: type,
            [CONTEXT]: context
        }

        this.trackMixpanel(CLICK, linkProps);
        if (gtmEvent) 
        this.trackGTM({
            event: gtmEvent,
            ...gtmProps
        })
    },

    resetUserTracking() {
        if (isActive(MIXPANEL_SWITCH))
            mixpanel.reset();
    },

    startUserTracking(userId) {
        if (isActive(GTM_SWITCH))
            TagManager.dataLayer({
                dataLayer: {
                    userId: UserService.isLoggedIn() ? UserService.getUser().id : "NIL",
                }
            });

        if (isActive(MIXPANEL_SWITCH))
            mixpanel.identify(userId)
    }

}

const TRACKING_CONSTANTS = {
    VIEW: "View",
    CLICK: "Link Clicked",
    REGISTRATION: "Registration"
}

const LINK_PROPS = {
    LABEL: "Label",
    TYPE: "Type",
    CONTEXT: "Context"
}

export const TRACKING_PAGE_PROPS = {
    VARIANT: "Variant",
    PAGE_NAME: "Page Name",
    PAGE_TITLE: "Title",
    DONATION_ID: "Donation Id",
    DONATION_AMOUNT: "Donation Amount"
}


export default Tracking;